<template>
	<footer>
		<div class="foot-top">
      <div class="content">

        <div class="fnav">

<!--          <a href="/about.html">关于站神</a>-->
<!--			<a href="#">营销方案</a>-->
<!--			<a href="#">营销快讯</a>-->
<!--			<a href="/agent.html">商务合作</a>-->
<!--			<a href="#">法律法规</a>-->
<!--			<a href="#">联系我们</a>-->
        </div>
      </div>
    </div>
	<div class="index-footer">
		<div class="content">
		<i class="top"><a href="/index.html">回到<br>主页</a></i>
		<div class="clear">Copyright ©2018-2030 深圳市单仁牛商络股份有限公司<em>|</em>地址：深圳市南山区同方信息港B栋3楼&nbsp;&nbsp;
            咨询服务热线：4000-333-087/售后请转3号键
				<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">粤ICP备09123656号</a>

			<span class="fr">
					股票代码：830770

			</span>
		</div>
		</div>
		</div>
	</footer>
</template>

<script>

export default {
	data () {
		return {
			routeName: ''
		}
	},
	watch: {
		'$route.name': {
			handler (val, oldVal) {
				this.routeName = val
				console.log(this.routeName)
			},
			immediate: true
		}
	}
}

</script>

<style lang="scss" scoped>
.content{width: 1200px; margin: 0 auto; position: relative;}
.foot-top{background: #e8f1f9;height: 89px;}


.fnav a {
    display: inline-block;
    line-height: 88px;
    margin-right: 45px;
    font-size: 16px;
}

.fnav a:last-child {
    margin-right: 0;
}
.index-footer {
	height: 94px;
	line-height: 94px;
	min-width: 1200px;
	background: #2b2b2b;
	font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
	&.fix-footer {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
	}
	div {
		width: 1200px;
		margin: 0 auto;
		font-size: 14px;
		color: #e0e0e0;
		em {
				display: inline-block;
				margin: 0 14px;
			}
		a {
			color: #e0e0e0;
		}
	}
}
.mr100 {
	margin-right: 100px;
}
@media (min-width: 1900px) {
	.index-footer {
		div {
			// width: 1828px;
		}
	}
}
.index-footer .top {
    display: block;
    width: 87px;
    height: 87px;
    position: absolute;
    right: -87px;
    top: -57px;
    float: right;
    z-index: 1;
    text-align: center;
    line-height: 20px;
    padding-top: 23px;
    background: #2664b2;
    border-radius: 50%;
    overflow: hidden;
    transition: all .1s linear;
    box-shadow: 0 0 20px rgba(48, 102, 182, 0.5);
}

.index-footer .top a {
    color: #fff;
    font-size: 16px;
    display: block;
}

</style>
